import { Navigate, Route, Routes } from "react-router-dom";
import Layout from "./components/shared/Layout";
import RequireAuth from "./components/auth/RequireAuth";
import useSession from "./hooks/useSession";
import PlatformPage from "./pages/PlatformPage";
import { RoutePath } from "./utilities/Constants";
import SolutionsPage from "./pages/SolutionsPage";
import ProductsPage from "./pages/products/ProductsPage";
import WhyUsPage from "./pages/WhyUsPage";
import LoginPage from "./pages/LoginPage";
import ProductsListPage from "./pages/products/ProductsListPage";
import ProductUniquePage from "./pages/products/ProductUniquePage";
import AddProductPage from "./pages/products/AddProductPage";
import ReviewListPage from "./pages/reviews/ReviewListPage";
import FooterPage from "./pages/footer/FooterPage";
import UniqueReviewPage from "./pages/reviews/UniqueReviewPage";
import AddReviewPage from "./pages/reviews/AddReviewPage";
import ClientListPage from "./pages/clients/ClientListPage";
import AddClientPage from "./pages/clients/AddClientPage";
import UniqueClientPage from "./pages/clients/UniqueClientPage";
import UserAuth from "./components/auth/UserAuth";

function App() {
  const [user] = useSession();

  const {
    platform,
    solutions,
    whyUs,
    login,
    productDetails,
    productList,
    productUnique,
    productAdd,
    clientList,
    clientAdd,
    clientUnique,
    reviewList,
    reviewUnique,
    reviewAdd,
    footer,
  } = RoutePath;

  return (
    <Routes>
      <Route
        path="/"
        element={
          <RequireAuth>
            <Layout />
          </RequireAuth>
        }
      >
        <Route
          index
          element={
            <Navigate
              to={user?.role === "admin" ? `/${platform}` : `/${login}`}
            />
          }
        />
        <Route path={platform} element={<PlatformPage />} />
        <Route path={solutions} element={<SolutionsPage />} />
        <Route path={productDetails} element={<ProductsPage />} />
        <Route path={productList} element={<ProductsListPage />} />
        <Route path={productUnique} element={<ProductUniquePage />} />
        <Route path={productAdd} element={<AddProductPage />} />
        <Route path={whyUs} element={<WhyUsPage />} />
        <Route path={clientList} element={<ClientListPage />} />
        <Route path={clientAdd} element={<AddClientPage />} />
        <Route path={clientUnique} element={<UniqueClientPage />} />
        <Route path={reviewList} element={<ReviewListPage />} />
        <Route path={reviewUnique} element={<UniqueReviewPage />} />
        <Route path={reviewAdd} element={<AddReviewPage />} />
        <Route path={footer} element={<FooterPage />} />
      </Route>
      <Route
        path={login}
        element={
          <UserAuth>
            <LoginPage />
          </UserAuth>
        }
      />
    </Routes>
  );
}

export default App;
